import { useEffect } from 'react'

/**
 * The styled-component global reset gets appended by nextjs AFTER the
 * css stylsheet, overwritting the CSS stylsheet for forms.
 * The hook finds the stylesheet link tag and appends it to the bottom
 * of the head tag so those styles no longer get overwritten
 */
const useAppendStyleSheet = () =>
  useEffect(() => {
    const links = document.getElementsByTagName('link')
    const link = Array.from(links).find(
      (link) => link.href.includes('_next') && link.rel === 'stylesheet'
    )

    if (link) {
      link.remove()
      document.head.appendChild(link)
    }
  }, [])

export default useAppendStyleSheet
